/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Image, Tooltip, OverlayTrigger } from 'react-bootstrap';

const getFirstLetterOfEachWord = (text?: string) =>
  text?.match(/\b\w/g).join('')?.substr(0, 2);

export const KanbanAvatar = (props: any) => {
  const { name, image } = props;

  const renderImageIf = () => {
    if (image) {
      return <Image rounded src={image} />;
    }
    if (name) {
      return (
        <div className="avatar fw-bold rounded bg-tertiary">
          <p
            style={{
              textAlign: 'center',
              alignSelf: 'center',
              justifyContent: 'center',
            }}
          >
            {getFirstLetterOfEachWord(name)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip className="m-0">{name}</Tooltip>}
    >
      <Card.Link href={`#${name}`} className="avatar ms-0">
        {renderImageIf()}
      </Card.Link>
    </OverlayTrigger>
  );
};
